import { ActionReducerMap } from '@ngrx/store';

import * as fromAuth from '../store/authentication/auth.reducer';
import * as menuReducer from '../store/menu/menu.reducer';
import * as fromReservation from '../store/reservation/reservation.reducer';
import {AppState} from './app.state';


export const reducers: ActionReducerMap<AppState> = {
  authentication: fromAuth.authReducer,
  menu: menuReducer.menuReducer,
  reservation : fromReservation.reservationReducer
};
